var convert = require('./convert'),
    func = convert('trim', require('../trim'));

func.placeholder = require('./placeholder');
module.exports = func;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash/fp/trim.js
// module id = 2414
// module chunks = 0